import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import AbteilungCreateButton from '#components/m/Versetzungsplan/AbteilungCreateButton'
import PublishAbteilungenModal from '#components/m/Versetzungsplan/PublishAbteilungenModal'
import FlyoutAnchor from '#components/m/Flyout/FlyoutAnchor'
import {FlyoutPosition} from '#components/m/Flyout/FlyoutPosition'
import {FlyoutPivot} from '#components/m/Flyout/FlyoutPivot'
import TerminCreateDialog from '#components/m/Versetzungsplan/TerminCreateDialog'
import Button from '#components/a/Button'
import i18n from 'i18next'
import AusbilderTerminCreateDialog from '#components/m/Versetzungsplan/AusbilderTerminCreateDialog'

export const VersetzungsplanHeaderButtons = ({
  canEditAbteilungseinaetze,
  canEditAzubiTermine,
  canEditAusbilderTermin,
  azubis,
  hasDraftEinsaetze,
  setCreateDialogOpen,
  createDialogOpen,
}) => {
  if (!azubis) {
    return null
  }
  const [showTerminDialog, setShowTerminDialog] = useState(false)
  return (
    <div className="headerButtons">
      {canEditAbteilungseinaetze && (
        <AbteilungCreateButton
          isPrimary={!hasDraftEinsaetze}
          setCreateDialogOpen={setCreateDialogOpen}
          createDialogOpen={createDialogOpen}
          azubis={azubis}
        />
      )}
      {canEditAzubiTermine && (
        <FlyoutAnchor
          flyoutPosition={FlyoutPosition.bottom}
          flyoutPivot={FlyoutPivot.end}
          openSync={showTerminDialog}
          flyoutVisibilityChanged={setShowTerminDialog}
          flyoutDistance={15}
          flyoutContent={<TerminCreateDialog toggleView={() => setShowTerminDialog(false)} />}>
          <Button id="create_termin" text={i18n.t('termin_erstellen')} variant="primary" />
        </FlyoutAnchor>
      )}
      {canEditAusbilderTermin && (
        <FlyoutAnchor
          flyoutPosition={FlyoutPosition.bottom}
          flyoutPivot={FlyoutPivot.end}
          openSync={showTerminDialog}
          flyoutVisibilityChanged={setShowTerminDialog}
          flyoutDistance={15}
          flyoutContent={<AusbilderTerminCreateDialog toggleView={() => setShowTerminDialog(false)} azubis={azubis} />}>
          <Button id="create_termin" text={i18n.t('termin_erstellen')} variant="primary" />
        </FlyoutAnchor>
      )}
      {canEditAbteilungseinaetze && <PublishAbteilungenModal azubis={azubis} disabled={!hasDraftEinsaetze} />}
    </div>
  )
}

VersetzungsplanHeaderButtons.propTypes = {
  canEditAbteilungseinaetze: PropTypes.bool.isRequired,
  canEditAzubiTermine: PropTypes.bool.isRequired,
  canEditAusbilderTermin: PropTypes.bool.isRequired,
  createDialogOpen: PropTypes.bool.isRequired,
  setCreateDialogOpen: PropTypes.func.isRequired,
  azubis: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      firstname: PropTypes.string,
      lastname: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  hasDraftEinsaetze: PropTypes.bool.isRequired,
}

function mapStateToProps(state) {
  if(state.authentication.permissions == undefined){
    return {
      canEditAbteilungseinaetze: false,
      canEditAzubiTermine: false,
      canEditAusbilderTermin: false,
      hasDraftEinsaetze: state.versetzungsplan.hasDraftEinsaetze,
    }
  }
  return {
    canEditAbteilungseinaetze: state.authentication.permissions.versetzungsplan.editAbteilungseinsaetze,
    canEditAzubiTermine: state.authentication.permissions.versetzungsplan.termine.editAzubiTermin,
    canEditAusbilderTermin: state.authentication.permissions.versetzungsplan.termine.editAusbilderTermin,
    hasDraftEinsaetze: state.versetzungsplan.hasDraftEinsaetze,
  }
}

export default connect(mapStateToProps)(VersetzungsplanHeaderButtons)
